export default "__VITE_ASSET__27a50e08__"